(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crg-shop-navigation"] && !Shopify.designMode) return;
  try {
    const crgMenuCache = new Map();
async function crgLoadMenu(item) {
  const content = item.querySelector(':scope > .crg-shop-panel > .crg-menu-content, :scope > .crg-menu-content');
  if (!content || content.dataset.menuLoaded || content.dataset.menuLoading) return;
  content.dataset.menuLoading = 'true';
  content.setAttribute('aria-busy', 'true');
  try {
    const url = new URL(content.dataset.menuUrl, location.origin);
    url.searchParams.set('section_id', 'crg-navigation-options');
    let html = crgMenuCache.get(url.href);
    if (!html) {
      const response = await fetch(url.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Menu unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = doc.querySelector('.crg-menu-content[data-menu-loaded]');
      if (!result) throw new Error('Menu unavailable');
      html = result.innerHTML;
      crgMenuCache.set(url.href, html);
    }
    content.innerHTML = html;
    content.dataset.menuLoaded = 'true';
  } catch (_) {
    content.dataset.menuLoading = '';
  } finally { content.removeAttribute('aria-busy'); }
}
document.addEventListener('toggle', (event) => {
  const item = event.target;
  if (!(item instanceof HTMLDetailsElement) || !item.open) return;
  if (item.matches('.crg-shop-drop, .crg-shop-subcat')) crgLoadMenu(item);
  if (item.matches('.crg-shop-drop')) document.querySelectorAll('.crg-shop-drop[open]').forEach(other => { if (other !== item) other.open = false; });
  if (item.matches('.crg-shop-subcat')) item.parentElement.querySelectorAll(':scope > .crg-shop-subcat[open]').forEach(other => { if (other !== item) other.open = false; });
}, true);
document.addEventListener('click', (event) => {
  const nav = event.target.closest('.crg-shop-nav');
  const toggle = event.target.closest('.crg-mobile-menu-toggle');
  if (toggle) { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); nav.toggleAttribute('data-mobile-open', open); return; }
  if (!nav) document.querySelectorAll('.crg-shop-nav[data-mobile-open]').forEach(n => { n.removeAttribute('data-mobile-open'); n.querySelector('.crg-mobile-menu-toggle').setAttribute('aria-expanded', 'false'); });
  if (!nav || event.target.closest('.crg-shop-close')) document.querySelectorAll('.crg-shop-drop[open]').forEach(item => { item.open = false; });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const item = event.target.closest?.('.crg-team-shortcut[open]') || document.querySelector('.crg-shop-drop[open]');
  if (item) { item.open = false; item.querySelector('summary').focus(); }
});

function crgFilterTeams(picker) {
  const query = picker.querySelector('[data-team-search]').value.trim().toLowerCase();
  const league = picker.querySelector('[data-team-league][aria-pressed="true"]').dataset.teamLeague;
  let count = 0;
  picker.querySelectorAll('.crg-team-results a').forEach(link => {
    const show = (!league || link.dataset.league === league) && link.textContent.toLowerCase().includes(query);
    link.hidden = !show;
    if (show) count++;
  });
  picker.querySelector('.crg-team-empty').hidden = count > 0;
}
document.addEventListener('input', event => {
  if (event.target.matches('[data-team-search]')) crgFilterTeams(event.target.closest('.crg-team-picker'));
});
document.addEventListener('click', event => {
  const button = event.target.closest('[data-team-league]');
  if (!button) return;
  const picker = button.closest('.crg-team-picker');
  picker.querySelectorAll('[data-team-league]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  crgFilterTeams(picker);
});
document.addEventListener('change', event => {
  if (event.target.matches('input[type="checkbox"]') && event.target.value === 'Sports Teams') {
    const entry = document.querySelector('.crg-headcover-team-entry details');
    if (entry) entry.open = event.target.checked;
  }
});
  } catch(e) { console.error(e); }
})();

})();
